import { useSandpack } from "@codesandbox/sandpack-react";

export default function GetFiles({
  handleSend,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSend: (...rest: any) => void;
}) {
  const { sandpack } = useSandpack();

  const handleSubmit = () => {
    const files = sandpack.files;
    handleSend(files);
  };

  return (
    <button className="practice-button" onClick={handleSubmit}>
      Gönder
    </button>
  );
}
